<div class="anchor" [class.open]="IsExpand">
    <div class="dropdown-collapse" [class.open]="IsExpand">
        <div
            class="dropdown"
            role="listbox"
            [tabindex]="IsExpand ? 0 : -1"
            [inert]="!IsExpand"
            (keydown.enter)="$event.stopPropagation()"
            (keydown.space)="$event.stopPropagation(); $event.preventDefault()"
            (click)="$event.stopPropagation()">
            <div class="inner">
                <upp-scrollable [scrollbar]="'y'">
                    <ion-list class="upp-select-dropdown-list">
                        <ng-content></ng-content>
                    </ion-list>
                </upp-scrollable>
            </div>
        </div>
    </div>
</div>
